export default {
  bookExperiencePanel: '预订体验面板',
  calendarIcon: '日历图标',
  coverImageForResource: '{{title}}体验的封面图片',
  filterBy: '按{{filter}}筛选',
  filterByDateRange: '按日期范围筛选',
  gallery: '图库',
  goBack: '返回上一页',
  hostUserIcon: '主办方用户图标',
  imageOf: '{{title}}的图片',
  interactiveMapAltText: '可选择{{title}}的交互式地图',
  mediaSlides: '媒体幻灯片',
  muteVideo: '静音视频',
  nextPhoto: '下一张照片',
  noVideoPlayback: '无视频播放功能',
  pauseVideo: '暂停视频',
  photoOf: '{{name}}的照片',
  playVideo: '播放视频',
  previousPhoto: '上一张照片',
  moreFiltersAndExperiences: '更多筛选条件和体验',
  reserveSelectedSlot: '预订所选时段',
  reviewRating: '评论评分 5 分中的 {{rating}} 分',
  overallReviewRating: '综合评论评分 5 分中的 {{rating}} 分',
  selectCountryCodeForPhoneNumber: '选择电话号码国家代码',
  selectDate: '选择日期',
  selectParticipants: '选择参与者',
  selectSessionTime: '选择课程时间',
  unmuteVideo: '取消静音视频',
  viewShoppingCart: '查看购物车',
  itemsInCart: '{{count}} 个物品在购物车中',
  zoomIn: '放大',
  zoomOut: '缩小',
  selectData: '选择{{data}}',
  reserveName: '预订{{name}}',
  deleteReservation: '删除{{experienceTitle}}预订',
  editParticipantsFor: '编辑{{experienceTitle}}的参与者',
  enterPromoCode: '输入优惠码',
  applyPromoCode: '应用优惠码',
  increaseAddOnAmount: '增加{{addOn}}选择',
  decreaseAddOnAmount: '减少{{addOn}}选择',
  addOnModal: '{{addOn}}模态框',
  moreInformationAboutAddOn: '关于{{addOn}}的更多信息',
  decreasePriceTierTickets: '减少{{priceTier}}票数',
  increasePriceTierTickets: '增加{{priceTier}}票数',
  downloadFilename: '下载{{filename}}',
  viewFullDetailsDescription: '查看完整详情描述',
  viewFullDescription: '查看完整描述',
  closeModal: '关闭模态框',
  hyattBanner: '凯悦天地会员专属横幅',
  hyattBannerDesc: '宣传横幅，显示提供给凯悦天地忠诚计划会员的专属福利和优惠',
  previousSlide: '上一张幻灯片',
  nextSlide: '下一张幻灯片',
  paginationBulletMessage: '转到幻灯片',
  exitFullscreen: '退出全屏模式',
  enterFullscreen: '进入全屏模式',
  videoSlide: '视频幻灯片',
  imageSlide: '图像幻灯片',
  of: '的',
  noDescription: '没有描述',
  mediaGallery: '轮播 - 媒体画廊',
  dateSelector: '日期选择器',
  nextWeek: '下一周',
  previousWeek: '上一周',
  scheduleAgenda: '日程安排',
  scheduleNav: '日程导航',
  scheduleViewSelector: '日程视图选择器',
  selectedDateAriaLabel: '{{date}}，已选择',
  tapToBookExperience: '预订 {{title}}',
  bookExperienceAriaLabel: '预订 {{title}}',
  joinWaitlistAriaLabel: '加入 {{title}} 候补名单',
};
